
const FeaturesImage = (selectedFeature) => {	
	return (
		<img style={{width:"100%"}} src={selectedFeature.selectedFeature}>
		</img>
	)
}

export default FeaturesImage